import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrlProvider } from './api-url.provider';
import { Invoice } from '../shared/models/invoice';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  constructor(
    private http: HttpClient,
    private apiUrlProvider: ApiUrlProvider) { 
    }

  download(docUrl: string, docType: number, filename: string, whenDone){
    let imageUrl = `${this.apiUrlProvider.url}/documents/${docUrl}?documentType=${docType}`;
    this.http
      .get(imageUrl, {responseType: 'blob'})
      .subscribe(res => {
        let objectUrl = window.URL.createObjectURL(res);
        let imageAnchor: HTMLAnchorElement = document.createElement("a");
        imageAnchor.href = objectUrl;
        imageAnchor.target = "_blank";
        imageAnchor.download = filename;
        imageAnchor.click();
        window.URL.revokeObjectURL(objectUrl);
      }, _ => {})
      .add(()=>{
        if (whenDone){
          whenDone();
        }
      });
  }
}
